import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, MESSAGES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'messageShortCodeStats',
  pluralName: 'messagesShortCodeStats',
  url: `${MESSAGES_URL}/short_code_stats`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
